var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomerPin = function SvgCustomerPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "68px",
    viewBox: "0 0 56 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-15",
    transform: "translate(-198.000000, -176.000000)",
    fill: "#E74C3C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-5",
    transform: "translate(198.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brand-Stuff/Pin/Consumer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brandmark_Consumer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8234559,0.082118984 C11.9406618,0.082118984 0.0553186275,12.0696858 0.0553186275,26.7031083 L0.0553186275,26.8502005 C0.0553186275,32.8710561 2.04134804,38.4181484 5.48561275,42.8634024 C9.55470588,48.118115 22.0367647,62.0729278 26.2600245,66.7780749 C26.6192108,67.1808503 27.1344819,67.4113612 27.6756373,67.4113612 C28.2167926,67.4113612 28.7320637,67.1808503 29.09125,66.7780749 C33.3099755,62.0720254 45.7639216,48.1199198 49.8729167,42.886865 C53.499992,38.2672201 55.4625048,32.5691009 55.4456967,26.7067179 L55.4456967,26.5596257 C55.4446814,11.9225936 43.7107843,0.082118984 27.8234559,0.082118984 Z M41.6376974,37.3406751 C41.6376974,38.0219678 41.0826718,38.5742647 40.3980147,38.5742647 L36.7578676,38.5742647 L36.7578676,38.5742647 L25.3985049,38.4425134 L15.0865686,38.5580214 C14.7552779,38.5618802 14.4362196,38.4336186 14.2005866,38.2018561 C13.9649536,37.9700936 13.8323775,37.6541172 13.8323775,37.3244318 L13.8323775,21.5458556 C13.8323775,21.1188279 14.0543298,20.7221752 14.4191176,20.4972594 L27.1859314,13.7165775 L36.9637255,20.8591243 L36.9637255,20.8735628 L40.3971078,20.8735628 C40.7263634,20.8733228 41.0421895,21.0034318 41.2749234,21.2351913 C41.5076572,21.4669507 41.6381779,21.7813199 41.6376974,22.1089572 L41.6376974,37.3406751 Z",
    id: "Shape"
  }))))))));
};
export default SvgCustomerPin;